import { RiskStatusResponse } from 'services/tenantManagementService';
import { RISK_STATUSES_FETCHING, RISK_STATUSES_SET } from './action';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';

export const riskStatusReducer = (state = new PersistItemsReducer<RiskStatusResponse>(), action: PersistItemsActionType<RiskStatusResponse> | FetchingActionType): PersistItemsReducer<RiskStatusResponse> => {
	switch (action.type) {
		case RISK_STATUSES_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case RISK_STATUSES_SET:
			const { items } = action as PersistItemsActionType<RiskStatusResponse>;

			const itemsMap: { [id: number]: RiskStatusResponse } = items.reduce(
                (map: { [id: number]: RiskStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
